<template>
  <div class="parkingViolationsPay">
    <div class="center">
      <span>罚款¥{{formData.violateAmount}}</span>
      <span>记{{formData.point}}分</span>
      <span>服务费¥{{formData.serviceAmount}}</span>
    </div>
    <div class="content">
      <div class="info">{{formData.violateAddr}}</div>
      <div class="info">{{formData.violateReason}}</div>
      <div class="info">{{formatDate(formData.violateDate)}}</div>
    </div>
    <div class="charge-view-right">
      <right-selector-new
        v-model="selectedRights"
        :rightOptions="rightOptions"
        :keyAdapter="{rightCode: 'rightCode'}"
        @select="selectRightClick"
        :isShowDetail="isShowDetail"
        :rightDiscount="rightDiscount"
      />
    </div>
    <div class="btn">
      <!-- <div class="agreement">
        <van-checkbox v-model="checked" shape="square" icon-size="0.25rem" class="agree">我已同意</van-checkbox>
        <span class="agreementInfo">《代办协议》</span>
      </div> -->
      <div class="btnBottom">
        <div class="number">罚款<span class="num">￥{{formData.violateAmount}}</span>  服务费<span class="num">￥{{formData.serviceAmount}} </span> <span v-if="isUseRight"> 权益优惠￥{{rightDiscount}}</span></div>
        <div class="total">合计:<span>￥{{total}}</span> 记<span>{{formData.point}}</span>分</div>
        <van-button type="info" @click="pay" size="large">立即支付</van-button>
      </div>
    </div>
    
  </div>
</template>
<script>
import dayjs from "dayjs";
import Pay from "@/common/weixin.js";
import { debounce } from "lodash";
import { findValidRight, getAllSimpleProductInfo, createOrder, carLifePayPre, carLifeOrderDetail } from "@/common/api.js";
import RightSelectorNew from '@/components/right-selector-new.vue';
import { CarLifeOrderStatus } from "@/common/constant.js";
export default {
  name: "parkingViolationsPay",
  components: {
    RightSelectorNew
  },
  data() {
    return {
      // checked: false,
      formData: {},
      rightDiscount: 0,
      selectedRights: {},
      rightOptions: [],
      orderNo: '',
      orderStatus: '',
      isShowDetail: true,
      total: 0
    }
  },
  // computed: {
  //   total() {
  //     const data = ((this.formData.violateAmount + this.formData.serviceAmount) - this.rightDiscount).toFixed(2)
  //     return data >= 0 ? data : 0
  //   }
  // },
  computed: {
    isUseRight () {
      return this.selectedRights.rightCode
    }
  },
  watch: {
    selectedRights(val){
      if(val.rightDiscount){
        const {totalAmount} = this.formData
        const _rightDiscount = val.rightRuleList[0].rightType === '2' ? this.formData.totalAmount : Number(val.rightDiscount)
        // 权益金额 大于 处罚金额，展示处罚金额
        this.rightDiscount = _rightDiscount > totalAmount ? totalAmount : _rightDiscount
        this.total = (totalAmount - _rightDiscount).toFixed(2)
      }else{
        this.total = this.formData.totalAmount
        this.rightDiscount = 0
      }
      if(this.total < 0){
        this.total = 0
      }
    }
  },
  mounted() {
    this.formData = JSON.parse(this.$route.query.formData)
    this.total = this.formData.totalAmount
    this.findValidRight()
    this.init()
  },
  methods: {
    init() {
      if (this.$route.query.orderNo) {
        let arr = this.$route.query.orderNo;
        if (Array.isArray(arr)) {
          this.orderNo = arr[arr.length - 1];
        } else {
          this.orderNo = this.$route.query.orderNo;
        }
      }
      if(this.$route.query.isCallBack){
        this.showConfirmDialog()
      }
    },
    showConfirmDialog() {
      this.$toast.loading({
        message: "支付结果检查中...",
        forbidClick: true,
        duration: 0,
      });
      this.checkPay();
      // this.prePaySuccess()
      // this.$toast.clear();
    },
    async checkPay() {
      try {
        let res = await carLifeOrderDetail({
          orderNo: this.orderNo,
        });
        this.$toast.clear();
        //待支付的，去订单详情
        if (res.rechargeStatus == CarLifeOrderStatus.unpaid) {
          this.prePayErr();
        } else {
          this.prePaySuccess();
        }
      } catch (error) {
        this.$toast.clear();
      }
    },
    //立即支付的
    pay: debounce(
      async function () {
        this.$toast.loading({
          message: "提交中",
          forbidClick: true,
          duration: 0,
        });
        try {
          const resp = await getAllSimpleProductInfo({productCode: this.$route.query.productCode})
          console.log(resp, 'resp');
          if(!resp){
            this.$toast('获取产品详情失败')
            return
          }
          const formData = {
            contactPhone: this.$route.query.phone,
            productSkuCode: resp.productStandardSkuRespVoList[0].productSkuCode,
            carNo: this.formData.carNo,
            vinNo: this.formData.vinNo,
            drivingLicense: this.formData.drivingLicense,
            drivingLicenseFile: this.formData.drivingLicenseFile,
            drivingLicenseCore: this.formData.drivingLicenseCore,
            drivingLicenseOssPath: this.formData.drivingLicenseOssPath,
            providerOrderNo: this.formData.providerOrderNo,
            numberPlateType : this.formData.numberPlateType,
            engineNo : this.formData.engineNo,
            violationReason: this.formData.violateReason,
            violationAddr: this.formData.violateAddr,
            punishAmount: this.formData.violateAmount,
            serviceAmount: this.formData.serviceAmount,
            punishDate: this.formData.violateDate,
            punishPoint: this.formData.point
          }
          let data = {}
          if(this.selectedRights.rightCode){
            const selectRights = {
              rightCode: this.selectedRights ? this.selectedRights.rightCode : '',
              rightPackageCode: this.selectedRights ? this.selectedRights.rightPackageCode : '',
              rightRuleCode: this.selectedRights ? this.selectedRights.rightRuleList[0].rightRuleCode : '',
              version: this.selectedRights ? this.selectedRights.version : '',
            }
            data = {...formData, ...selectRights}
          }else{
            data = formData
          }
          const res = await createOrder(data)
          this.orderNo = res.orderNo
          this.orderStatus = res.orderStatus
          if (res.needPay) {
            const envMap = ["1", "1", "4"];
            //调起预支付接口成功后
            let prepayRs = await carLifePayPre({
              payType: envMap[this.$browserEnv], //支付环境
              orderNo: this.orderNo,
            });
            this.prePayHandle(prepayRs);
          }else{
            this.prePaySuccess()
          }
        } catch (error) {
          console.log(error, 'err');
        }
        this.$toast.clear()
      },
      3000,
      { leading: true, trailing: false }
    ),
    prePayHandle(payload) {
      const _payload = {
        appId: payload.appId,
        timeStamp: payload.timeStamp,
        nonceStr: payload.nonceStr,
        package: payload.packageValue,
        signType: payload.signType,
        paySign: payload.paySign,
        prepayId: payload.prepayId,
        mwebUrl: payload.mwebUrl,
      };
      switch (this.$browserEnv) {
        case 0:
          Pay.mpPay(_payload, this.orderNo, 'ticket');
          break;
        case 1:
          Pay.wxPay(_payload, this.prePaySuccess, this.prePayErr);
          break;
        case 2:
          Pay.browserPay(_payload.mwebUrl, this.orderNo, 'ticket');
          break;
      }
    },
    prePaySuccess() {
      this.$router.replace({
        name: "resultPage",
        query: {
          orderNo: this.orderNo,
          orderStatus: CarLifeOrderStatus.success,
          orderType: "04",
          phone: this.$route.query.phone,
          categoryCode: this.$route.query.categoryCode,
        },
      });
      // this.$router.replace({
      //   path: "/pvOrderDetail",
      //   query: {
      //     orderNo: this.orderNo,
      //   },
      // });
    },
    prePayErr() {
      this.$toast('支付失败')
      this.$router.replace({
        path: "/pvOrderDetail",
        query: {
          orderNo: this.orderNo,
        },
      });
    },

    // 获取权益
    async findValidRight() {
      const data = {
        phone: this.$route.query.phone,
        productCode: this.$route.query.productCode,
      }
      const res = await findValidRight(data)
      this.rightOptions = res
      this.rightOptions.forEach((item) => {
          item.rightId = item.rightPackageCode + "-" + item.rightCode;
          item.timesLeft = item.validCount;
          // item.disabled = true; //都是禁用的
        });
    },
    selectRightClick(item) {
      this.selectedRights = item;
      // this.rightDiscount = item.rightDiscount ? Number(item.rightDiscount) : 0
    },
    formatDate(date) {
      return dayjs(date).format("YYYY-MM-DD hh:mm:ss");
    },
  }
}
</script>
<style scoped lang="scss">
.parkingViolationsPay{
  width: 100%;
  background: #F4F6F7;
  height: 100vh;
  font-size: 0.36rem;
  font-family:'Microsoft YaHei';
  .center{
    background: #fff;
    padding: 0 0.4rem;
    height: 1rem;
    line-height: 1rem;
    font-weight: 600;
    margin-bottom: 0.03rem;
    border-top: 0.3rem solid #F4F6F7;
    span{
      margin-right: 0.2rem;
      color: #383838;
      font-size: 0.3rem;
    }
  }
  .content{
    padding: 0.1rem 0.4rem;
    box-sizing: border-box;
    background: #fff;
    .info{
      color: #383838;
      font-size: 0.28rem;
      margin: 0.24rem 0;
      line-height: 0.24rem;
    }
  }
  .cell{
    padding-top: 0.3rem;
  }
  .btn{
    position: fixed;
    bottom: 0;
    background: #fff;
    /deep/ .van-button{
      border-radius: 0.16rem;
    }
    .agreement{
      display: flex;
      align-items: center;
      font-size: 0.2rem;
      background: #F2F9FF;
      padding: 0.1rem 0.4rem;
      .agree{
        color: #787878;
      }
      .agreementInfo{
        color: #5986B3;
      }
    }
    .btnBottom{
      width: 100vw;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      padding: 0 0.4rem 0.3rem;
      box-sizing: border-box;
      .number{
        color: #999999;
        font-size: 0.2rem;
        text-align: center;
        width: 100vw;
        height: 0.8rem;
        line-height: 0.8rem;
        .num{
          margin-right: 0.1rem;
        }
      }
      .total{
        color: #383838;
        font-size: 0.32rem;
        text-align: center;
        margin-bottom: 0.25rem;
        span{
          color: #EA3F26;
        }
      }
    }
  }
}
</style>